// ⚠️ Este arquivo pode ser gerado automaticamente via generate-env.js
export const environment = {
  production: false,
  requireAuth: true,
  apiUrl: 'https://experimentos-data-dev-api.enacloud.me/api/v1',
  socketUrl: 'https://experimentos-data-dev-api.enacloud.me/api/v1',

  urlFront: 'plataforma-experiment-dev.enacloud.me',
  redirectUri: 'plataforma-experiment-dev.enacloud.me',

  apiUrlBuffer: '',
  token: '',

  // ENACOM
  client: 'f3685b6e-ca89-492b-b22b-c03866066741',
  authority: 'https://login.microsoftonline.com/efa10a2e-43c9-4e1e-8b6f-e1dd91403848',

  // MApE²
  urlMapeRedirect: 'https://frontend-mape-dev.enacloud.me',
};
